import Concat from './concat/index.js'
import CopyWithin from './copy-within/index.js'
import Fill from './fill/index.js'
import Pop from './pop/index.js'
import Push from './push/index.js'
import Reverse from './reverse/index.js'
import Shift from './shift/index.js'
import Splice from './splice/index.js'
import Unshift from './unshift/index.js'
export default {
  concat: Concat,
  copyWithin: CopyWithin,
  fill: Fill,
  pop: Pop,
  push: Push,
  reverse: Reverse,
  shift: Shift,
  splice: Splice,
  unshift: Unshift,
}